"use client";

import HighchartsReact from "highcharts-react-official";
import { useMemo } from "react";
import * as HighCharts from "highcharts";

HighCharts.setOptions({
  colors: [
    "rgba(5,141,199,0.5)",
    "rgba(80,180,50,0.5)",
    "rgba(237,86,27,0.5)",
    "rgba(255,165,0,0.5)",
    "rgba(128,0,128,0.5)",
    "rgba(205, 217, 76, 1)",
    "rgba(87, 76, 217, 1)",
    "rgba(138, 217, 76, 1)",
    "rgba(217, 211, 76, 1)",
    "rgba(155, 76, 217, 1)",
    "rgba(217, 76, 211, 1)",
    "rgba(217, 127, 76, 1)",
    "rgba(217, 177, 76, 1)",
    "rgba(121, 76, 217, 1)",
    "rgba(217, 76, 110, 1)",
    "rgba(76, 217, 200, 1)",
    "rgba(217, 143, 76, 1)",
    "rgba(76, 217, 132, 1)",
    "rgba(121, 217, 76, 1)",
    "rgba(217, 194, 76, 1)",
    "rgba(76, 132, 217, 1)",
    "rgba(205, 76, 217, 1)",
    "rgba(76, 200, 217, 1)",
    "rgba(76, 183, 217, 1)",
    "rgba(217, 76, 76, 1)",
    "rgba(76, 98, 217, 1)",
    "rgba(76, 81, 217, 1)",
    "rgba(87, 217, 76, 1)",
    "rgba(76, 115, 217, 1)",
    "rgba(217, 76, 127, 1)",
    "rgba(76, 217, 183, 1)",
    "rgba(76, 166, 217, 1)",
    "rgba(76, 149, 217, 1)",
    "rgba(217, 76, 143, 1)",
    "rgba(76, 217, 166, 1)",
    "rgba(76, 217, 149, 1)",
    "rgba(217, 110, 76, 1)",
    "rgba(76, 217, 98, 1)",
    "rgba(172, 217, 76, 1)",
    "rgba(76, 217, 81, 1)",
    "rgba(155, 217, 76, 1)",
    "rgba(189, 76, 217, 1)",
    "rgba(76, 217, 217, 1)",
    "rgba(217, 76, 194, 1)",
    "rgba(138, 76, 217, 1)",
    "rgba(217, 93, 76, 1)",
    "rgba(217, 76, 93, 1)",
    "rgba(189, 217, 76, 1)",
    "rgba(217, 76, 160, 1)",
    "rgba(217, 76, 177, 1)",
    "rgba(172, 76, 217, 1)",
    "rgba(76, 217, 115, 1)",
    "rgba(104, 217, 76, 1)",
    "rgba(217, 160, 76, 1)",
    "rgba(104, 76, 217, 1)",
  ],
});

const markerSymbols = ["circle", "triangle", "square", "diamond", "pentagon"];

function formatKeyWithSpaces(key: any) {
  return key
    ?.split("_")
    ?.map((word: any) => word.charAt(0).toUpperCase() + word.slice(1))
    ?.join(" ");
}

function ScatterCharts({ data = [] }) {
  const series: any = useMemo(() => {
    const seriesMap: any = {};
    data?.forEach(({ year, ...fields }: any) => {
      Object.entries(fields)?.forEach(([key, value]) => {
        if (!seriesMap[key]) {
          seriesMap[key] = {
            name: formatKeyWithSpaces(key),
            data: [],
            marker: {
              symbol:
                markerSymbols[
                  Object.keys(seriesMap)?.length % markerSymbols?.length
                ],
            },
          };
        }
        seriesMap[key]?.data?.push([year, value || 0]);
      });
    });
    return Object.values(seriesMap);
  }, [data]);

  const options = {
    chart: {
      type: "scatter",
      zoomType: "xy",
    },
    title: {
      text: null,
    },
    xAxis: {
      title: {
        text: "Year",
      },
      allowDecimals: false,
    },
    yAxis: {
      title: {
        text: "Value",
      },
    },
    legend: {
      enabled: true,
    },
    plotOptions: {
      scatter: {
        marker: {
          radius: 5,
          states: {
            hover: {
              enabled: true,
              lineColor: "rgb(100,100,100)",
            },
          },
        },
        states: {
          hover: {
            marker: {
              enabled: false,
            },
          },
        },
      },
    },
    tooltip: {
      headerFormat: `<b>{series.name}</b><br>`,
      pointFormat: "Year: {point.x}, Value: {point.y}",
    },
    series,
  };

  return (
    <div>
      {series.length > 0 ? (
        <HighchartsReact highcharts={HighCharts} options={options} />
      ) : (
        <p>Loading chart data...</p>
      )}
    </div>
  );
}

export { ScatterCharts };
